import { render, staticRenderFns } from "./UploadMaterial.vue?vue&type=template&id=6fe15434&scoped=true"
import script from "./UploadMaterial.vue?vue&type=script&lang=ts"
export * from "./UploadMaterial.vue?vue&type=script&lang=ts"
import style0 from "./UploadMaterial.vue?vue&type=style&index=0&id=6fe15434&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe15434",
  null
  
)

export default component.exports